import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& ul': {
      padding: 0,
    },
  },
  input: {
    width: 320,
  },
  linearProgress: {
    marginTop: 10,
  },
  usersList: {
    height: 200,
    border: '1px solid',
    marginTop: 10,
    overflow: 'auto',
  },
  applyFilterBtn: {
    color: Colors.Green,
  },
}));

export default useStyles;